module.exports = __webpack_public_path__ + "static/media/Clock 5-ax.71e3aa4c.svg";